import { EQuizMode } from '@constants';
import { ISubscription } from '@sdk/contracts';
import { useQuery } from '@tanstack/react-query';
import Cookies from 'js-cookie';
import { useMemo } from 'react';
import { create as createStore } from 'zustand';

import { useProfile } from '../profile';

import { sdk } from '@/services';

interface IStore {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  selectedSubscription?: ISubscription;
  setSelectedSubscription: (subscriptionSelected?: ISubscription) => void;
}

const SubscriptionService = sdk.getService('SubscriptionService');

const store = createStore<IStore>(set => ({
  isOpen: false,
  setIsOpen: (isOpen: boolean) => set({ isOpen }),
  setSelectedSubscription: (selectedSubscription?: ISubscription) => {
    set({ selectedSubscription });
    if (selectedSubscription) {
      Cookies.set('selectedSubscriptionId', selectedSubscription._id, { expires: 365 });
    }
  }
}));

export const useMySubscriptionsWithQuizCourses = (mode: EQuizMode) => {
  const { profile } = useProfile();
  const { selectedSubscription, setSelectedSubscription, isOpen, setIsOpen } = store();

  const { isLoading, data, error } = useQuery({
    queryKey: ['subscriptions', mode],
    queryFn: () => SubscriptionService.getMySubscriptionsWithQuizCourses(mode),
    enabled: !!profile
  });

  const filteredSubscriptions = useMemo(() => data?.filter(s => !s.isHidden), [data]);

  const planificableSubscriptions = useMemo(
    () => filteredSubscriptions?.filter(s => s.course.isPlanificable),
    [filteredSubscriptions]
  );

  return {
    isOpen,
    setIsOpen,
    error,
    isLoading,
    subscriptions: data,
    selectedSubscription,
    filteredSubscriptions,
    planificableSubscriptions,
    setSelectedSubscription
  };
};
